// ======================================================================
// File Name       : HiddenStatusSettingFunctionDisplay
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Form, Col } from 'react-bootstrap';
import { HIDDEN_STATUS } from '../../constants/EnterpriseConstants';

function HiddenStatusSettingFunctionDisplay({ label, name, value, onChange, isDisabled }) {
  return (
    <Form.Group className="form-info">
      <Col sm={3} as={Form.Label}>{label}</Col>
      <Col lg={2} sm={3} className="padding-top-10">
        <Form.Check
          type='radio'
          inline
          className="padding-top-clear"
          name={name}
          id={`${name}-${HIDDEN_STATUS.SHOW_ALL}`}
          value={HIDDEN_STATUS.SHOW_ALL}
          checked={value === HIDDEN_STATUS.SHOW_ALL}
          onChange={onChange}
          disabled={isDisabled}
          label='全て表示'></Form.Check>
      </Col>
      <Col lg={2} sm={3} className="padding-top-10">
        <Form.Check
          type='radio'
          inline
          className="padding-top-clear"
          name={name}
          id={`${name}-${HIDDEN_STATUS.KNOWLEDGE_BASE}`}
          value={HIDDEN_STATUS.KNOWLEDGE_BASE}
          checked={value === HIDDEN_STATUS.KNOWLEDGE_BASE}
          onChange={onChange}
          disabled={isDisabled}
          label='マニュアルのみ表示'></Form.Check>
      </Col>
      <Col lg={2} sm={3} className="padding-top-10">
        <Form.Check
          type='radio'
          inline
          className="padding-top-clear"
          name={name}
          id={`${name}-${HIDDEN_STATUS.HIDE_ALL}`}
          value={HIDDEN_STATUS.HIDE_ALL}
          checked={value === HIDDEN_STATUS.HIDE_ALL}
          onChange={onChange}
          disabled={isDisabled}
          label='非表示'></Form.Check>
      </Col>
    </Form.Group>
  );
}

export default HiddenStatusSettingFunctionDisplay;
